export const LIST_QUESTION = "LIST_QUESTION"
export const SELECT_OPTION_MENU_QUESTION = "SELECT_OPTION_MENU_QUESTION"
export const CHANGE_MENU_OPTIONS_QUESTION = "CHANGE_MENU_OPTIONS_QUESTION"